import { KYB_STATUSES } from '@/shared/constants/store-constants/account'

export default {
  requisites: null,
  isLoading: false,
  isLoaded: false,

  kybStatus: KYB_STATUSES.UNSPECIFIED,
  kybStatusUpdatedAt: null,
  isKybStatusLoading: false,
  isKybStatusLoaded: false,
}
